import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-flashlight-line',
      title: 'Emergency Work',
      slug: 'emergency-work',
      description: '24/7 emergency electrical services for urgent repairs and safety issues',
      image: 'https://public.readdy.ai/ai/img_res/b2b9a726a7bac0fab830cab9f235c9ee.jpg'
    },
    {
      icon: 'ri-wind-line',
      title: 'Ceiling Fans',
      slug: 'ceiling-fans',
      description: 'Professional installation and repair of ceiling fans for optimal comfort',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20in%20branded%20orange%20and%20navy%20company%20uniform%20with%20logo%20patch%20on%20chest%20installing%20modern%20ceiling%20fan%20in%20contemporary%20home%20interior%2C%20professional%20workwear%20with%20company%20branding%20clearly%20visible%2C%20clean%20white%20ceiling%2C%20bright%20natural%20lighting%2C%20photorealistic%20corporate%20uniform%20photography&width=600&height=400&seq=service-ceiling-fan-branded-uniform-202&orientation=landscape'
    },
    {
      icon: 'ri-plug-line',
      title: 'Power Points',
      slug: 'power-points',
      description: 'Installation and upgrade of power points and outlets throughout your property',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20wearing%20branded%20orange%20and%20dark%20navy%20company%20uniform%20with%20logo%20embroidered%20on%20chest%20installing%20modern%20power%20outlet%20in%20contemporary%20home%20wall%2C%20professional%20company%20workwear%20clearly%20visible%2C%20organized%20wiring%2C%20bright%20lighting%2C%20photorealistic%20corporate%20branding%20photography&width=600&height=400&seq=service-power-points-branded-uniform-203&orientation=landscape'
    },
    {
      icon: 'ri-search-line',
      title: 'Fault Detection',
      slug: 'fault-detection',
      description: 'Advanced diagnostic tools to identify and resolve electrical faults quickly',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20in%20branded%20orange%20and%20navy%20company%20uniform%20with%20logo%20on%20chest%20using%20digital%20multimeter%20to%20detect%20electrical%20faults%20in%20switchboard%2C%20company%20workwear%20with%20embroidered%20logo%20clearly%20visible%2C%20professional%20diagnostic%20tools%2C%20photorealistic%20corporate%20uniform%20photography&width=600&height=400&seq=service-fault-detection-branded-uniform-204&orientation=landscape'
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Smoke Alarms',
      slug: 'smoke-alarms',
      description: 'Installation, testing, and maintenance of smoke alarms for your safety',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20wearing%20branded%20orange%20and%20dark%20navy%20company%20uniform%20with%20logo%20embroidered%20on%20chest%20installing%20smoke%20alarm%20on%20white%20ceiling%20in%20residential%20home%2C%20professional%20company%20workwear%20clearly%20visible%2C%20safety%20compliance%20work%2C%20bright%20clean%20environment%2C%20photorealistic%20corporate%20branding%20photography&width=600&height=400&seq=service-smoke-alarms-branded-uniform-205&orientation=landscape'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Lighting',
      slug: 'lighting',
      description: 'Complete lighting solutions including LED upgrades and smart lighting',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20in%20branded%20orange%20and%20navy%20company%20uniform%20with%20logo%20patch%20on%20chest%20installing%20modern%20LED%20recessed%20lighting%20in%20contemporary%20home%20ceiling%2C%20professional%20company%20workwear%20with%20embroidered%20branding%20clearly%20visible%2C%20beautiful%20ambient%20lighting%2C%20photorealistic%20corporate%20uniform%20photography&width=600&height=400&seq=service-lighting-branded-uniform-206&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: 'Electrical Repairs',
      slug: 'electrical-repairs',
      description: 'Expert repairs for all types of electrical issues and malfunctions',
      image: 'https://readdy.ai/api/search-image?query=Skilled%20electrician%20wearing%20branded%20orange%20and%20dark%20navy%20company%20uniform%20with%20logo%20embroidered%20on%20chest%20repairing%20electrical%20wiring%20with%20professional%20tools%20in%20residential%20setting%2C%20company%20workwear%20clearly%20visible%2C%20organized%20repair%20work%2C%20bright%20lighting%2C%20photorealistic%20corporate%20branding%20photography&width=600&height=400&seq=service-repairs-branded-uniform-207&orientation=landscape'
    },
    {
      icon: 'ri-git-branch-line',
      title: 'Wiring & Rewiring',
      slug: 'wiring-rewiring',
      description: 'Complete wiring services for new installations and renovations',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20in%20branded%20orange%20and%20navy%20company%20uniform%20with%20logo%20on%20chest%20performing%20electrical%20rewiring%20work%20in%20modern%20home%2C%20organized%20color-coded%20cable%20management%2C%20company%20workwear%20with%20embroidered%20logo%20clearly%20visible%2C%20professional%20tools%2C%20photorealistic%20corporate%20uniform%20photography&width=600&height=400&seq=service-wiring-branded-uniform-208&orientation=landscape'
    },
    {
      icon: 'ri-shield-flash-line',
      title: 'Surge Protection',
      slug: 'surge-protection',
      description: 'Protect your valuable electronics with professional surge protection',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20wearing%20branded%20orange%20and%20dark%20navy%20company%20uniform%20with%20logo%20embroidered%20on%20chest%20installing%20surge%20protection%20device%20in%20electrical%20panel%2C%20professional%20company%20workwear%20clearly%20visible%2C%20advanced%20safety%20components%2C%20organized%20wiring%2C%20photorealistic%20corporate%20branding%20photography&width=600&height=400&seq=service-surge-branded-uniform-209&orientation=landscape'
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Switchboards',
      slug: 'switchboards',
      description: 'Switchboard upgrades and repairs for improved safety and efficiency',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20in%20branded%20orange%20and%20navy%20company%20uniform%20with%20logo%20patch%20on%20chest%20working%20on%20modern%20electrical%20switchboard%20circuit%20breaker%20panel%20upgrade%2C%20company%20workwear%20with%20embroidered%20branding%20clearly%20visible%2C%20organized%20professional%20installation%2C%20photorealistic%20corporate%20uniform%20photography&width=600&height=400&seq=service-switchboards-branded-uniform-210&orientation=landscape'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Electrical Maintenance',
      slug: 'electrical-maintenance',
      description: 'Regular maintenance services to keep your electrical systems running smoothly',
      image: 'https://readdy.ai/api/search-image?query=Electrician%20wearing%20branded%20orange%20and%20dark%20navy%20company%20uniform%20with%20logo%20embroidered%20on%20chest%20performing%20routine%20electrical%20maintenance%20inspection%20with%20checklist%20and%20testing%20equipment%2C%20professional%20company%20workwear%20clearly%20visible%2C%20thorough%20inspection%20process%2C%20photorealistic%20corporate%20branding%20photography&width=600&height=400&seq=service-maintenance-branded-uniform-211&orientation=landscape'
    },
    {
      icon: 'ri-battery-charge-line',
      title: 'Solar Batteries',
      slug: 'solar-batteries',
      description: 'Installation and maintenance of solar battery storage systems',
      image: 'https://readdy.ai/api/search-image?query=Professional%20electrician%20in%20branded%20orange%20and%20navy%20company%20uniform%20with%20logo%20on%20chest%20installing%20modern%20solar%20battery%20storage%20system%2C%20company%20workwear%20with%20embroidered%20logo%20clearly%20visible%2C%20clean%20renewable%20energy%20installation%2C%20bright%20technical%20environment%2C%20photorealistic%20corporate%20uniform%20photography&width=600&height=400&seq=service-solar-branded-uniform-212&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-14 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block bg-[#f67f19] text-white px-4 py-2 rounded-full font-bold text-xs md:text-sm mb-4 md:mb-6 uppercase tracking-wide">
            Our Services
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-[#535669] mb-3 md:mb-4 leading-tight">
            Complete Electrical Solutions
          </h2>
          <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto">
            From emergency repairs to complete installations, we provide comprehensive electrical services for residential and commercial properties
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-10 md:mb-16">
          {services.map((service, index) => (
            <Link
              key={index}
              to={`/services/${service.slug}`}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer group block"
            >
              <div className="relative h-40 md:h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute top-3 right-3 md:top-4 md:right-4 w-12 h-12 md:w-14 md:h-14 bg-[#f67f19] rounded-full flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-xl md:text-2xl text-white`}></i>
                </div>
              </div>
              <div className="p-4 md:p-6">
                <h3 className="text-lg md:text-xl font-bold text-[#535669] mb-2 md:mb-3 leading-tight">{service.title}</h3>
                <p className="text-xs md:text-sm text-gray-600 mb-3 md:mb-4 leading-relaxed">{service.description}</p>
                <span className="text-[#f67f19] font-bold text-xs md:text-sm hover:text-[#e06e0a] transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer group">
                  Learn More
                  <i className="ri-arrow-right-line text-sm md:text-base group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="bg-[#535669] text-white p-6 md:p-12 rounded-2xl shadow-xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-48 h-48 md:w-64 md:h-64 bg-[#f67f19]/10 rounded-full -mr-24 -mt-24 md:-mr-32 md:-mt-32"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 md:w-48 md:h-48 bg-[#f67f19]/10 rounded-full -ml-16 -mb-16 md:-ml-24 md:-mb-24"></div>
          <div className="relative z-10 text-center max-w-3xl mx-auto">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-[#f67f19] rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6">
              <i className="ri-customer-service-2-fill text-2xl md:text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4">Need Emergency Electrical Service?</h3>
            <p className="text-sm md:text-lg mb-6 md:mb-8 text-gray-300">We're available 24/7 for urgent electrical repairs and emergencies. Our team is ready to help you right now.</p>
            <a
              href="tel:0416497716"
              className="w-full md:w-auto inline-flex items-center justify-center gap-2 md:gap-3 bg-[#f67f19] text-white px-6 py-3 md:px-10 md:py-5 rounded-full font-bold text-base md:text-lg hover:bg-[#e06e0a] transition-all whitespace-nowrap cursor-pointer shadow-xl hover:shadow-2xl hover:scale-105"
            >
              <i className="ri-phone-fill text-xl md:text-2xl"></i>
              Call Now: 0416 497 716
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}